var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4113 14.1095C33.252 13.5319 32.9411 13.0053 32.5097 12.5822C32.0782 12.1591 31.5413 11.8542 30.9524 11.6979C28.7963 11.1212 20.1194 11.1212 20.1194 11.1212C20.1194 11.1212 11.4421 11.1387 9.28635 11.7154C8.69745 11.8717 8.16057 12.1766 7.72918 12.5997C7.29779 13.0228 6.98694 13.5494 6.82758 14.127C6.17542 17.8845 5.9224 23.6097 6.84542 27.2167C7.00478 27.7943 7.31563 28.3209 7.74702 28.744C8.17841 29.1672 8.71529 29.4721 9.30419 29.6284C11.4602 30.205 20.1372 30.205 20.1372 30.205C20.1372 30.205 28.8143 30.205 30.9702 29.6284C31.5591 29.4721 32.096 29.1672 32.5274 28.744C32.9588 28.3209 33.2697 27.7943 33.429 27.2167C34.1167 23.454 34.3288 17.7324 33.4112 14.1097L33.4113 14.1095Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3575 24.7526L24.5558 20.6632L17.3575 16.5737V24.7526Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_2438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19.3333,
    fill: "white",
    transform: "translate(5.5 11.1212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.b40408a2eeaf66fe5420763496d4ca0f.svg";
export { ForwardRef as ReactComponent };